export default __webpack_public_path__ + "static/media/tour-9.6bdba3c0.png";